import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Bridge between the app-level side navigation and the designer-level leave
 * confirmation dialog. The designer subscribes to `requests$` and shows its
 * own confirmation popup; on confirm, it invokes the stored callback.
 *
 * Scoped to Product Blueprint Modeler only — the side nav decides whether to call
 * `request()` based on the current URL.
 */
@Injectable({ providedIn: 'root' })
export class LeaveConfirmationService {
    private requests = new Subject<() => void>();
    requests$ = this.requests.asObservable();

    request(onConfirm: () => void): void {
        this.requests.next(onConfirm);
    }
}
